'use client';
import Home from './index';

export default function HomeSwitch() {
  return <Home layoutVersion="2" />;
}
